/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListTemplateChat } from '../models/api-response-list-template-chat';
import { ApiResponsePagedResultTemplateChat } from '../models/api-response-paged-result-template-chat';
import { ApiResponseTemplateChat } from '../models/api-response-template-chat';
import { createTemplate } from '../fn/template-chat-api/create-template';
import { CreateTemplate$Params } from '../fn/template-chat-api/create-template';
import { deleteTemplate } from '../fn/template-chat-api/delete-template';
import { DeleteTemplate$Params } from '../fn/template-chat-api/delete-template';
import { getTemplateByReference } from '../fn/template-chat-api/get-template-by-reference';
import { GetTemplateByReference$Params } from '../fn/template-chat-api/get-template-by-reference';
import { listTemplateChats } from '../fn/template-chat-api/list-template-chats';
import { ListTemplateChats$Params } from '../fn/template-chat-api/list-template-chats';
import { patchArchiveStatus } from '../fn/template-chat-api/patch-archive-status';
import { PatchArchiveStatus$Params } from '../fn/template-chat-api/patch-archive-status';
import { patchEligibilityUiStatus } from '../fn/template-chat-api/patch-eligibility-ui-status';
import { PatchEligibilityUiStatus$Params } from '../fn/template-chat-api/patch-eligibility-ui-status';
import { searchListTemplate } from '../fn/template-chat-api/search-list-template';
import { SearchListTemplate$Params } from '../fn/template-chat-api/search-list-template';
import { searchTemplates } from '../fn/template-chat-api/search-templates';
import { SearchTemplates$Params } from '../fn/template-chat-api/search-templates';
import { updateTemplate } from '../fn/template-chat-api/update-template';
import { UpdateTemplate$Params } from '../fn/template-chat-api/update-template';

@Injectable({ providedIn: 'root' })
export class TemplateChatApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getTemplateByReference()` */
  static readonly GetTemplateByReferencePath = '/v1/api/ui/templates-chat/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTemplateByReference()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemplateByReference$Response(params: GetTemplateByReference$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateChat>> {
    return getTemplateByReference(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTemplateByReference$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTemplateByReference(params: GetTemplateByReference$Params, context?: HttpContext): Observable<ApiResponseTemplateChat> {
    return this.getTemplateByReference$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTemplateChat>): ApiResponseTemplateChat => r.body)
    );
  }

  /** Path part for operation `updateTemplate()` */
  static readonly UpdateTemplatePath = '/v1/api/ui/templates-chat/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTemplate$Response(params: UpdateTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateChat>> {
    return updateTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTemplate(params: UpdateTemplate$Params, context?: HttpContext): Observable<ApiResponseTemplateChat> {
    return this.updateTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTemplateChat>): ApiResponseTemplateChat => r.body)
    );
  }

  /** Path part for operation `deleteTemplate()` */
  static readonly DeleteTemplatePath = '/v1/api/ui/templates-chat/{reference}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTemplate$Response(params: DeleteTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTemplate(params: DeleteTemplate$Params, context?: HttpContext): Observable<void> {
    return this.deleteTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createTemplate()` */
  static readonly CreateTemplatePath = '/v1/api/ui/templates-chat';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTemplate$Response(params: CreateTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateChat>> {
    return createTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTemplate(params: CreateTemplate$Params, context?: HttpContext): Observable<ApiResponseTemplateChat> {
    return this.createTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseTemplateChat>): ApiResponseTemplateChat => r.body)
    );
  }

  /** Path part for operation `searchTemplates()` */
  static readonly SearchTemplatesPath = '/v1/api/ui/templates-chat/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchTemplates()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTemplates$Response(params: SearchTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultTemplateChat>> {
    return searchTemplates(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchTemplates$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchTemplates(params: SearchTemplates$Params, context?: HttpContext): Observable<ApiResponsePagedResultTemplateChat> {
    return this.searchTemplates$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultTemplateChat>): ApiResponsePagedResultTemplateChat => r.body)
    );
  }

  /** Path part for operation `searchListTemplate()` */
  static readonly SearchListTemplatePath = '/v1/api/ui/templates-chat/search-list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchListTemplate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchListTemplate$Response(params: SearchListTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultTemplateChat>> {
    return searchListTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchListTemplate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchListTemplate(params: SearchListTemplate$Params, context?: HttpContext): Observable<ApiResponsePagedResultTemplateChat> {
    return this.searchListTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultTemplateChat>): ApiResponsePagedResultTemplateChat => r.body)
    );
  }

  /** Path part for operation `listTemplateChats()` */
  static readonly ListTemplateChatsPath = '/v1/api/ui/templates-chat/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listTemplateChats()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTemplateChats$Response(params: ListTemplateChats$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListTemplateChat>> {
    return listTemplateChats(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listTemplateChats$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listTemplateChats(params: ListTemplateChats$Params, context?: HttpContext): Observable<ApiResponseListTemplateChat> {
    return this.listTemplateChats$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListTemplateChat>): ApiResponseListTemplateChat => r.body)
    );
  }

  /** Path part for operation `patchEligibilityUiStatus()` */
  static readonly PatchEligibilityUiStatusPath = '/v1/api/ui/templates-chat/eligibility-ui/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchEligibilityUiStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchEligibilityUiStatus$Response(params: PatchEligibilityUiStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchEligibilityUiStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchEligibilityUiStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchEligibilityUiStatus(params: PatchEligibilityUiStatus$Params, context?: HttpContext): Observable<void> {
    return this.patchEligibilityUiStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchArchiveStatus()` */
  static readonly PatchArchiveStatusPath = '/v1/api/ui/templates-chat/archive/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchArchiveStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchArchiveStatus$Response(params: PatchArchiveStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchArchiveStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchArchiveStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchArchiveStatus(params: PatchArchiveStatus$Params, context?: HttpContext): Observable<void> {
    return this.patchArchiveStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
